module.exports = __webpack_public_path__ + "static/media/mentor-matcher-free-no-bg.d407bc18.svg";